<template>
  <v-card>
    <v-form ref="form" :lazy-validation="true">
      <v-card-title>
        <h4>Lägg till kommentar</h4>
      </v-card-title>

      <v-card-text>
        <v-textarea outlined label :rules="[rules.required]" v-model="comment" rows="5"></v-textarea>
      </v-card-text>

      <v-card-actions class="justify-end">        
        <v-btn color="secondary" @click="$emit('close')">
          <v-icon>$sl-cancel</v-icon>Avbryt
        </v-btn>
        <v-btn @click="save">
          <v-icon>$sl-check</v-icon>Spara
        </v-btn>
      </v-card-actions>
    </v-form>
  </v-card>
</template>

<script>
import API from '@/services/api.js'
import {RulesMixin} from '@/components/mixins'
// @group Order
// OrderAddComment component
export default {
  name: 'OrderAddComment',

  props: {
    //has dialog to be open
    // `true` / `false`
    openDialog: Boolean
  },

  mixins: [RulesMixin],

  data: () => ({
    comment: ''
  }),

  watch: {
    openDialog() {
      this.comment = ''
      this.$refs.form.resetValidation()
    }
  },

  methods: {
    save() {
      //- Valid ?
      if (!this.$refs.form.validate()) {
        return this.$events.fire('showError', 'Formuläret är inte korrekt ifyllt.')
      }
      // Fire save event
      // @arg The argument is string representing Comment
      this.$emit('save', this.comment)
    }
  }
}
</script>
<style lang="scss">
.v-textarea.v-text-field--enclosed .v-text-field__slot textarea {
  line-height: 1.6;
}
</style>